/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Uploadfailed1Inputs */

const en_errors_uploadfailed1 = /** @type {(inputs: Errors_Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload failed`)
};

/**
* | output |
* | --- |
* | "Upload failed" |
*
* @param {Errors_Uploadfailed1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errors_uploadfailed1 = /** @type {((inputs?: Errors_Uploadfailed1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Uploadfailed1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errors_uploadfailed1(inputs)
});
export { errors_uploadfailed1 as "errors_uploadFailed" }